import { useState } from "react";

import { Button, ButtonIconWithLabel, Icon_OpenNew24, Link } from "@shapr3d/frontend-lib";

import { CollaborationPromoURL } from "../../config";
import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";
import { ElementClickAction, ElementClickLocation } from "../../lib/TrackingAdapter";
import { PublishVersionModal } from "./components/PublishVersionModal";

import style from "./PublishVersionPromo.module.css";

interface PublishVersionPromoProps {
  canPublish: boolean;
  backgroundImage?: string;
}

export const PublishVersionPromo = ({ canPublish, backgroundImage }: PublishVersionPromoProps) => {
  const tracker = useTracker();
  const { t, m } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.title}>
          {canPublish ? t(m.PublishVersion.PromoTitle) : t(m.PublishVersion.NoVersionTitle)}
        </div>
        <div className={style.description}>
          {canPublish ? t(m.PublishVersion.PromoDescription) : t(m.PublishVersion.EditorRequired)}
        </div>
        <div className={style.actions}>
          {canPublish && (
            <Button
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <ButtonIconWithLabel
                icon={<Icon_OpenNew24 />}
                label={t(m.PublishVersion.PublishCurrentVersion)}
              />
            </Button>
          )}
          <Link
            href={CollaborationPromoURL}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.LEARN_MORE_PUBLISHING_VERSIONS,
                location: ElementClickLocation.PROJECT_PAGE,
              });
            }}
          >
            {t(m.PublishVersion.LearnMoreLink)}
          </Link>
        </div>
      </div>
      {canPublish && (
        <PublishVersionModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
      )}
      {backgroundImage && (
        <>
          <img src={backgroundImage} alt="" aria-hidden="true" className={style.backgroundImage} />
          <div className={style.overlay} />
        </>
      )}
    </div>
  );
};
